import axios from '@/plugins/axios';
import { API_G_150_HAISO_MST_MENTE } from '@/constants/api';
import type { Module } from 'vuex';
import { isShorikbADD, isShorikbUPD, isShorikbDELCANCEL } from '@/utils/utils';
/* 不要なパラメータを取り除く場合
import { removeBlankOrNullOrZero } from '@/utils/utils';
*/
import { haisoMstType } from '@/types/G_kaigai/G_150_HaisoMstMente';

export type G_150 = {
  haisoList: haisoMstType[];
  haisoMst: haisoMstType;
};

const g_150: Module<G_150, unknown> = {
  namespaced: true,
  state() {
    return {
      haisoList: [],
      haisoMst: {},
    };
  },
  mutations: {
    SET_HAISO_LIST(state, payload: haisoMstType[]) {
      state.haisoList = payload;
    },
    SET_HAISO_MST(state, payload: haisoMstType) {
      state.haisoMst = payload;
    },
    RESET_HAISO_LIST(state) {
      state.haisoList = [];
    },
    RESET_HAISO_MST(state) {
      state.haisoMst = {};
    },
  },
  getters: {
    haisoList: (state) => state.haisoList,
    haisoMst: (state) => state.haisoMst,
  },
  actions: {
    // 問合せ画面の data 取得
    async getHaisoList({ commit }, params) {
      try {
        const res = await axios({
          url: `${API_G_150_HAISO_MST_MENTE}`,                   
          params,
          method: 'GET',
        });
        commit('SET_HAISO_LIST',
          res.data.responseData && res.data.responseData.length > 0
            ? res.data.responseData
            : []);
        return await Promise.resolve(res);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    // ヘッダ入力画面の data 取得
    async getHaisoMst({ commit }, params) {
      //console.log(`getHaisoMst params: ${JSON.stringify(params)}`); //デバッグ？
      try {
        // ↓ 悩んだ末に「GET」に関してはこの url の記述を踏襲する
        const res = await axios({
          url: `${API_G_150_HAISO_MST_MENTE}/${params.itakusakiCd}`,
          params,
          method: 'GET',
        });
        const { responseData } = res.data;
        commit('SET_HAISO_MST', responseData);
        return await Promise.resolve(res);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    //  問合せ画面の API 呼び出しで error が帰ってきた場合、一覧を clear する必要がある
    resetHaisoList({ commit }) {
      commit('RESET_HAISO_LIST');
    },
    // ヘッダ入力画面を ADD で起動する場合、store を reset する必要がある
    resetHaisoMst({ commit }) {
      commit('RESET_HAISO_MST');
    },
    
    //更新API
    async postPutHaisoMst(_ctx, reqObj) {
      //let url = API_G_150_HAISO_MST_MENTE;     
      let w_method: any = 'PUT';
  
      if (isShorikbUPD(reqObj.shoriKb) || isShorikbDELCANCEL(reqObj.shoriKb)) {
        //更新系は requestBodyで統一したい
        //url += '/' + reqObj.requestBody.requestData.himmokuDaibunruiMstData.daibunruiCd;
      }
      if (isShorikbADD(reqObj.shoriKb)) {
        w_method = 'POST';
      }  
      const res = await axios({
        //url: url,
        url: `${API_G_150_HAISO_MST_MENTE}`,
        data: reqObj.requestBody,
        method: w_method,
      });
      return await Promise.resolve(res);
    },
    
    // 削除API
    async deleteHaisoMst(_ctx, reqObj) {  
      const res = await axios({
        //url: url,
        url: `${API_G_150_HAISO_MST_MENTE}`,
        data: reqObj.requestBody,
        method: 'DELETE',
      });
      return await Promise.resolve(res);
    },
  },
};

export default g_150;
